import isDefined from '../../utils/guards/isDefined';
import type { Lucid } from '../../types/types';

type WithNavFooterMenu = (
  nav: {
    footer: Lucid.Directus.Generated.Footer[];
  },
  id: number,
  shortCode: Lucid.I18n.LanguagesShortCode,
) => Lucid.Directus.Generated.Footer_Column_Translations[];

const withNavFooterMenu: WithNavFooterMenu = (nav, id, shortCode) => {
  const selectedSections = (nav.footer.find(menu => menu.id === `${id}`)?.columns || [])
    .map(section => section.footer_column_id)
    .filter(isDefined);

  const sections = selectedSections?.reduce<Lucid.Directus.Generated.Footer_Column_Translations[]>(
    (previous, current) => {
      const currentSection = current?.translations?.find(tr => tr.languages_code?.short_code === shortCode);
      if (currentSection) return [...previous, currentSection];

      return previous;
    },
    [],
  );

  return sections;
};

export default withNavFooterMenu;
